(function () {
  "use strict";

  if (window.OMTHeaderOffsets && window.OMTHeaderOffsets.__initialized) {
    return;
  }

  var COLLAPSE_SCROLL_MIN = 64;
  var EXPAND_SCROLL_MAX = 8;
  var SCROLL_DELTA_THRESHOLD = 12;
  var EXPAND_DELTA_THRESHOLD = 20;
  var DEFAULT_ANCHOR_EXTRA = 60;
  var TRANSITION_DURATION = 320;
  var RESIZE_WIDTH_THRESHOLD = 16;

  var state = {
    collapsed: false,
    lastAppliedCollapsed: null,
    lastScrollY: 0,
    lastViewportWidth: 0,
    appliedPlaceholderHeight: 0,
    ticking: false,
    transitionTimer: null,
    transitionLockUntil: 0,
    suppressCompensation: false,
    lastDispatch: {
      collapsed: null,
      stackHeight: null,
      stickyTop: null
    },
    metrics: {
      countdownHeight: 0,
      toolbarHeight: 0,
      headerHeight: 0,
      placeholderHeight: 0,
      stackHeight: 0,
      stickyTop: 0,
      anchorOffset: 0
    }
  };

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function getViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function isTransitionLocked() {
    return Date.now() < state.transitionLockUntil;
  }

  function lockTransition() {
    state.transitionLockUntil = Date.now() + TRANSITION_DURATION;
  }

  function getElements() {
    return {
      body: document.body,
      countdown: document.querySelector(".omt-count-down-section .countdown-suction-cap"),
      toolbar: document.querySelector('[data-section-type="toolbar"]'),
      header: document.querySelector('[data-section-type="header"]'),
      placeholder: document.querySelector(".header-placeholder"),
      mask: document.querySelector(".site-navigation-mask"),
      festivalsCountdown: document.querySelector(".festivals-countdown-suction-cap")
    };
  }

  function isVisible(element) {
    if (!element || !document.documentElement.contains(element)) {
      return false;
    }

    var style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden") {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getHeight(element) {
    return isVisible(element) ? element.offsetHeight : 0;
  }

  function setRootVar(name, value) {
    document.documentElement.style.setProperty(name, Math.max(Math.round(value), 0) + "px");
  }

  function setImportantStyle(element, property, value) {
    if (!element) {
      return;
    }

    element.style.setProperty(property, value, "important");
  }

  function clearStyles(element, properties) {
    if (!element) {
      return;
    }

    properties.forEach(function (property) {
      element.style.removeProperty(property);
    });
  }

  function getCountdownTransform(offsetY) {
    return "translate3d(-50%, " + offsetY + "px, 0)";
  }

  function getVerticalTransform(offsetY) {
    return "translate3d(0, " + offsetY + "px, 0)";
  }

  function isPdpAnchorActive() {
    return document.body && document.body.getAttribute("data-omt-pdp-anchor") === "active";
  }

  function getPdpAnchorHeight() {
    var value = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--omt-pdp-anchor-height"),
      10
    );
    return isNaN(value) ? 0 : Math.max(value, 0);
  }

  function measure() {
    var elements = getElements();
    var countdownHeight = getHeight(elements.countdown);
    var toolbarHeight = getHeight(elements.toolbar);
    var headerHeight = getHeight(elements.header);
    // 文档流占位始终按展开态整栈，折叠/PDP 切换不改占位，避免移动端 scrollTo 抖动环
    var placeholderHeight = countdownHeight + toolbarHeight + headerHeight;
    var pdpActive = isPdpAnchorActive();
    var pdpHeight = pdpActive ? getPdpAnchorHeight() : 0;
    var visibleCountdownHeight = state.collapsed || pdpActive ? 0 : countdownHeight;
    var visibleToolbarHeight = state.collapsed || pdpActive ? 0 : toolbarHeight;
    var visibleHeaderHeight = pdpActive ? 0 : headerHeight;
    // 可见吸顶高度：供 sticky / drawer / mask 消费（语义不变）
    var stackHeight = pdpActive
      ? pdpHeight
      : visibleHeaderHeight + visibleToolbarHeight + visibleCountdownHeight;
    var stickyTop = stackHeight;
    var anchorOffset = stickyTop + DEFAULT_ANCHOR_EXTRA;

    state.metrics = {
      countdownHeight: countdownHeight,
      toolbarHeight: toolbarHeight,
      headerHeight: headerHeight,
      placeholderHeight: placeholderHeight,
      stackHeight: stackHeight,
      stickyTop: stickyTop,
      anchorOffset: anchorOffset
    };

    setRootVar("--omt-countdown-height", countdownHeight);
    setRootVar("--omt-toolbar-height", toolbarHeight);
    setRootVar("--omt-header-height", headerHeight);
    setRootVar("--omt-placeholder-height", placeholderHeight);
    setRootVar("--omt-header-stack-height", stackHeight);
    setRootVar("--omt-sticky-top", stickyTop);
    setRootVar("--omt-anchor-offset", anchorOffset);

    return elements;
  }

  /**
   * 仅在真实占位高度变化时补偿（如 countdown 业务隐藏、断点重测）。
   * 折叠态 / PDP 切换不改 placeholder，禁止 scrollTo，避免触摸滚动抖动环。
   */
  function compensateScrollForPlaceholderChange(prevPlaceholderHeight, nextPlaceholderHeight) {
    if (state.suppressCompensation) {
      return;
    }

    if (prevPlaceholderHeight === nextPlaceholderHeight) {
      return;
    }

    var scrollY = getScrollY();
    if (scrollY <= 0) {
      return;
    }

    var compensation = prevPlaceholderHeight - nextPlaceholderHeight;
    if (!compensation) {
      return;
    }

    var nextScrollY = Math.max(0, scrollY + compensation);
    window.scrollTo(0, nextScrollY);
    state.lastScrollY = nextScrollY;
  }

  function dispatchOffsets() {
    var metrics = state.metrics;
    var last = state.lastDispatch;

    if (
      last.collapsed === state.collapsed &&
      last.stackHeight === metrics.stackHeight &&
      last.stickyTop === metrics.stickyTop
    ) {
      return;
    }

    state.lastDispatch = {
      collapsed: state.collapsed,
      stackHeight: metrics.stackHeight,
      stickyTop: metrics.stickyTop
    };

    document.dispatchEvent(
      new CustomEvent("omt:header-offsets", {
        detail: {
          collapsed: state.collapsed,
          countdownHeight: metrics.countdownHeight,
          toolbarHeight: metrics.toolbarHeight,
          headerHeight: metrics.headerHeight,
          placeholderHeight: metrics.placeholderHeight,
          stackHeight: metrics.stackHeight,
          stickyTop: metrics.stickyTop,
          anchorOffset: metrics.anchorOffset
        }
      })
    );
  }

  function applyState() {
    var prevPlaceholderHeight =
      state.appliedPlaceholderHeight || state.metrics.placeholderHeight || 0;
    var elements = measure();
    var nextPlaceholderHeight = state.metrics.placeholderHeight;

    if (!elements.body || !elements.header) {
      return;
    }

    compensateScrollForPlaceholderChange(prevPlaceholderHeight, nextPlaceholderHeight);
    state.appliedPlaceholderHeight = nextPlaceholderHeight;

    elements.body.setAttribute("data-omt-header-state", state.collapsed ? "collapsed" : "expanded");
    if (state.lastAppliedCollapsed !== null && state.lastAppliedCollapsed !== state.collapsed) {
      lockTransition();
      elements.body.classList.add("omt-header-transitioning");
      if (state.transitionTimer) {
        window.clearTimeout(state.transitionTimer);
      }
      state.transitionTimer = window.setTimeout(function () {
        elements.body.classList.remove("omt-header-transitioning");
        state.transitionTimer = null;
      }, TRANSITION_DURATION);
    }
    state.lastAppliedCollapsed = state.collapsed;

    setImportantStyle(elements.countdown, "top", "0px");
    setImportantStyle(elements.toolbar, "top", state.metrics.countdownHeight + "px");
    setImportantStyle(
      elements.header,
      "top",
      state.metrics.countdownHeight + state.metrics.toolbarHeight + "px"
    );
    // 占位只绑展开态整栈；折叠/PDP 不改文档流
    setImportantStyle(elements.placeholder, "height", state.metrics.placeholderHeight + "px");

    if (elements.mask) {
      elements.mask.style.top = state.metrics.stackHeight + "px";
      elements.mask.style.height = "calc(100vh - " + state.metrics.stackHeight + "px)";
    }

    if (elements.festivalsCountdown) {
      setImportantStyle(elements.festivalsCountdown, "top", state.metrics.stackHeight + "px");
    }

    if (state.metrics.countdownHeight > 0) {
      if (isPdpAnchorActive()) {
        elements.countdown.style.transform = getCountdownTransform(0);
        elements.countdown.style.pointerEvents = "none";
      } else {
        elements.countdown.style.transform = state.collapsed
          ? getCountdownTransform(-state.metrics.countdownHeight)
          : getCountdownTransform(0);
        elements.countdown.style.pointerEvents = state.collapsed ? "none" : "";
      }
    } else {
      clearStyles(elements.countdown, ["transform", "pointer-events"]);
    }

    if (state.metrics.toolbarHeight > 0) {
      if (isPdpAnchorActive()) {
        elements.toolbar.style.transform = getVerticalTransform(0);
        elements.toolbar.style.pointerEvents = "none";
      } else {
        elements.toolbar.style.transform = state.collapsed
          ? getVerticalTransform(-(state.metrics.countdownHeight + state.metrics.toolbarHeight))
          : getVerticalTransform(0);
        elements.toolbar.style.pointerEvents = state.collapsed ? "none" : "";
      }
    } else {
      clearStyles(elements.toolbar, ["transform", "pointer-events"]);
    }

    if (isPdpAnchorActive()) {
      clearStyles(elements.header, ["transform"]);
      if (elements.header) {
        elements.header.style.pointerEvents = "none";
      }
    } else if (state.metrics.countdownHeight > 0 || state.metrics.toolbarHeight > 0) {
      elements.header.style.transform = state.collapsed
        ? getVerticalTransform(-(state.metrics.countdownHeight + state.metrics.toolbarHeight))
        : getVerticalTransform(0);
      if (elements.header) {
        elements.header.style.pointerEvents = "";
      }
    } else {
      clearStyles(elements.header, ["transform", "pointer-events"]);
    }

    dispatchOffsets();
  }

  function syncFromScroll() {
    state.ticking = false;

    if (isTransitionLocked()) {
      return;
    }

    // PDP 锚点顶替 Header 栈时，跳过折叠态切换，避免与锚点显隐抢滚动位置
    if (isPdpAnchorActive()) {
      state.lastScrollY = getScrollY();
      return;
    }

    var currentScrollY = getScrollY();
    var delta = currentScrollY - state.lastScrollY;
    state.lastScrollY = currentScrollY;

    if (currentScrollY <= EXPAND_SCROLL_MAX) {
      if (state.collapsed) {
        state.collapsed = false;
        applyState();
      }
      return;
    }

    if (Math.abs(delta) <= SCROLL_DELTA_THRESHOLD) {
      return;
    }

    if (delta > 0 && currentScrollY > COLLAPSE_SCROLL_MIN) {
      if (!state.collapsed) {
        state.collapsed = true;
        applyState();
      }
      return;
    }

    if (delta < -EXPAND_DELTA_THRESHOLD && state.collapsed) {
      state.collapsed = false;
      applyState();
    }
  }

  function requestSync() {
    if (state.ticking) {
      return;
    }

    state.ticking = true;
    window.requestAnimationFrame(syncFromScroll);
  }

  function refresh() {
    state.lastScrollY = getScrollY();
    state.lastViewportWidth = getViewportWidth();
    if (!isPdpAnchorActive()) {
      state.collapsed = state.lastScrollY > COLLAPSE_SCROLL_MIN;
    }
    applyState();
  }

  /** 地址栏显隐只改高度：不 measure / 不改 placeholder / 不 scrollTo */
  function onViewportResize() {
    var nextWidth = getViewportWidth();
    var prevWidth = state.lastViewportWidth || nextWidth;
    var widthDelta = Math.abs(nextWidth - prevWidth);

    if (widthDelta < RESIZE_WIDTH_THRESHOLD) {
      state.lastScrollY = getScrollY();
      return;
    }

    state.lastViewportWidth = nextWidth;
    refresh();
  }

  /** PDP 锚点切换专用：更新 offset，但不 scrollTo 补偿（占位已解耦，仍保留 suppress 以防占位实测抖动） */
  function refreshFromPdpAnchor() {
    state.suppressCompensation = true;
    state.lastScrollY = getScrollY();
    applyState();
    state.suppressCompensation = false;
  }

  window.OMTHeaderOffsets = {
    __initialized: true,
    getStickyTop: function () {
      return state.metrics.stickyTop;
    },
    getAnchorOffset: function (extra) {
      return state.metrics.stickyTop + (typeof extra === "number" ? extra : DEFAULT_ANCHOR_EXTRA);
    },
    getHeaderHeight: function () {
      return state.metrics.headerHeight;
    },
    getToolbarHeight: function () {
      return state.metrics.toolbarHeight;
    },
    getCountdownHeight: function () {
      return state.metrics.countdownHeight;
    },
    getPlaceholderHeight: function () {
      return state.metrics.placeholderHeight;
    },
    isCollapsed: function () {
      return state.collapsed;
    },
    refresh: refresh,
    refreshFromPdpAnchor: refreshFromPdpAnchor
  };

  function init() {
    state.lastScrollY = getScrollY();
    state.lastViewportWidth = getViewportWidth();
    state.collapsed = state.lastScrollY > COLLAPSE_SCROLL_MIN;
    applyState();

    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", onViewportResize);
    window.addEventListener("orientationchange", refresh);
    window.addEventListener("load", refresh);
    document.addEventListener("shopify:section:load", refresh);
    document.addEventListener("omt:countdown-visibility-change", refresh);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
